import { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";

interface Props {
  brandName: string;
  code?: string;
  shopUrl: string;
  description?: string;
}

export function PartnerPromoBlock({ brandName, code, shopUrl, description }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!code) return;
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div
      className="my-10 rounded-2xl border-2 p-7"
      style={{ backgroundColor: "var(--color-surface)", borderColor: "var(--color-sage-light)" }}
    >
      <p className="eyebrow">🌿 Code promo exclusif Rénergescence</p>
      <h3 className="mt-2 font-display text-2xl" style={{ color: "var(--color-dark)" }}>{brandName}</h3>
      {description && <p className="mt-2 text-sm" style={{ color: "var(--color-text)" }}>{description}</p>}

      {code && (
        <div className="mt-5 flex flex-wrap items-center gap-4">
          <code
            className="rounded-lg px-5 py-3 font-mono text-xl font-bold tracking-widest"
            style={{ backgroundColor: "var(--color-background)", color: "var(--color-dark)", border: "1px dashed var(--color-sage)" }}
          >
            {code}
          </code>
          <button
            onClick={copy}
            className="inline-flex items-center gap-2 text-sm font-medium transition-colors"
            style={{ color: "var(--color-sage-text)" }}
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? "Copié" : "Copier le code"}
          </button>
        </div>
      )}

      <a
        href={shopUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-4 inline-flex items-center gap-2 text-sm font-medium"
        style={{ color: "var(--color-dark)" }}
      >
        Visiter la boutique <ExternalLink size={14} />
      </a>
    </div>
  );
}
